import React from 'react';
import FilmCard, { FilmCardData } from '../FilmCard/FilmCard';
import './FilmGrid.css';

interface FilmGridProps {
  films: FilmCardData[];
  currentPage: number;
  itemsPerPage?: number;
  onFilmClick?: (film: FilmCardData) => void;
}

const FilmGrid: React.FC<FilmGridProps> = ({ 
  films, 
  currentPage, 
  itemsPerPage = 10,
  onFilmClick 
}) => {
  // Calculate which films to display based on current page
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const displayedFilms = films.slice(startIndex, endIndex);

  return (
    <div className="film-grid" data-scroll-section="film-grid">
      {displayedFilms.map((film) => (
        <FilmCard 
          key={film.id} 
          film={film}
          onClick={() => onFilmClick?.(film)}
        />
      ))}
    </div>
  );
};

export default FilmGrid;